module.exports = __webpack_public_path__ + "media/images/edit-icon-d221204e781cd692fff3defa0f890151.png";